
/**************************************************************************
 * Created on Mon Nov 04 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

import DSSButton from '../../atoms/dss-button';
import { useModal } from './context/ModalContext';
import DSSModal from '../../atoms/dss-modal';
import { CSSProperties } from 'react';



export const AlertConfirmationModal = () =>
{

    const { isOpen, dialogmsg, title, cancelButtonText, doneButtonText, modalType, onClose, onDone, closeConfirmModal } = useModal();


    const styles = {
        container: {
            width: "30vw",
            height: "40vh"
        } as CSSProperties,
        title: {
            width: "100%",
            padding: "1rem",
            borderBottom: "1px solid #303030",
            fontSize: "1.25rem",
            fontWeight: "700",
            textAlign: "left"
        } as CSSProperties,
        body: {
            width: "100%",
            height: "58%",
            padding: "0.3rem",
            textAlign: "left",
            fontSize: "1.5rem"

        } as CSSProperties,
        footer: {
            width: "100%",
            height: "30%",
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem",
            alignItems: "center",
            padding: "1rem",
            borderTop: "1px solid #030303"
        } as CSSProperties
    }


    return (
        <>

            { isOpen && <DSSModal
                id="general"
                isOpen={ isOpen }
                isShowClose={ true }
                className='globalmodal'
                onClose={
                    () =>
                    {
                        closeConfirmModal();
                        onClose && onClose();
                    }
                }>
                <div style={ styles.container }>
                    <div style={ styles.title }>

                        { title }
                    </div>
                    <div style={ styles.body }>
                        { dialogmsg }
                    </div>
                    <div style={ styles.footer }>
                        <DSSButton id="confirmcancel"
                            variant="secondary"
                            style={ {
                                minWidth: "20%",
                                padding: "0.4rem"
                            } }
                            onClick={ () =>
                            {
                                closeConfirmModal();
                                onClose && onClose()
                            } }>{ cancelButtonText }</DSSButton>
                        { modalType === 'CONFIRM' && <DSSButton id="confirmcancel"
                            variant="primary"
                            style={ {
                                minWidth: "20%",
                                padding: "0.4rem"
                            } }
                            onClick={ () =>
                            {

                                closeConfirmModal();
                                onDone && onDone()
                            } } >{ doneButtonText }</DSSButton> }
                    </div>

                </div>
            </DSSModal >
            }
        </>
    )
}
